export const POSTFIX_BOOK_CODE_SG = "-SG";

export const bookIdRegex = /b[0-9]*/;

export const folderIdRegex = /^[0-9]+$/;

export const langRegex = /^[a-z]+$/;

export const bookIdRegexStrict = new RegExp(`^${bookIdRegex.source}$`);

export const paraWithoutPrefixRegExp = /(\d+)\.(\d+)/;

export const NKJV_BIBLE = "b14334";
export const DEFAULT_BIBLE = {
  en: "1965",
};

export const BOOK_TYPE = {
  book: "book",
  bible: "bible",
  apl: "apl",
  manuscript: "manuscript",
  periodical: "periodical",
  dictionary: "dictionary",
};

export const LANGUAGE_DIRECTION = {
  rightToLeft: "rtl",
}

export const BOOK_TYPES = Object.values(BOOK_TYPE);

export const BOOK_SUB_TYPE = {
  commentary: "commentary",
  noPageBreaks: "no pagebreaks",
  empty: "",
};

export const FOLDER_TYPE = {
  bible: "bible",
  apl: "apl",
  egwwritings: "egwwritings",
  reference: "reference",
};

export const BOOK_PERMISSION = {
  purchased: "purchased",
  authenticated: "authenticated",
  public: "public",
};

export const TREE_LABEL_HIDE_IN_TREE = "none";

export const CLASSNAME_READER_DEV_ID_ITEM = "dev-id-item";

export const CONTENT_CLASSES = {
  EGW_WRITINGS: FOLDER_TYPE.egwwritings,
  EGW_LINK: "egwlink",
  EGW_LINK_BOOK: "egwlink_book",
  EGW_LINK_BIBLE: "egwlink_bible",
  EGW_LINK_EXTERNAL: "egwlink_external",
  BOOKS: "books",
  BOOK: BOOK_TYPE.book,
  READER_HEADER_TEXT: "readerHeaderText",
  PAGE_NUMBER: "readerPageNumber",
  REF_CODE: "refCode",
  DICTIONARY: BOOK_TYPE.dictionary,
  REFERENCE: FOLDER_TYPE.reference,
  PAGE_BREAK: "page-break",
  PARAGRAPH: "para",
  PICTURE: "para-picture",
  CHAPTER: "chapter",
  LANGUAGE: "language",
  FOLDER: "folder",
  ICON_TRANSLATE: "reader-translate-icon",
  ICON_BIBLE: "egw-bible-icon",

  CATEGORIES_ROOT: "categories-root",
  CATEGORIES_CATEGORY: "categories-category",
  CATEGORIES_BOOK: "categories-book",
  CATEGORIES_LANGUAGE_FOLDER: "categories-language-folder",
  CATEGORIES_BOOK_TRANSLATION: "categories-book-translation",

  TITLES_ROOT: "titles-root",
  TITLES_CATEGORY: "titles-category",
  TITLES_BOOK: "titles-book",
  TITLES_LANGUAGE_FOLDER: "titles-language-folder",
  TITLES_BOOK_TRANSLATION: "titles-book-translation",

  TREE_ITEM: "tree-item",

  FOOT_NOTE: "footnote",
  CHAPTER_END_NOTE: "chapterendnote",
  BOOK_END_NOTE: "bookendnote",
  SC_MARK: "sc-mark",
  SC_NOTE: "sc-note",
  SC_BOOKMARK: "sc-bookmark",
  SC_HIGHLIGHT: "hh",
};
